import { ApolloClient, createHttpLink, from, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { serverPort, serverScheme, serverUrl } from "../config";
import { doLogout } from "../store/actions/UserActions";
import { store } from '../store/index';
import { sweetAlertToast } from "../helpers";

const GRAPHQL_ENDPOINT = '/graphql';
const JWT_TOKEN_KEY = 'jwtToken';
const UNAUTHORIZED_STATUS = 401;

const buildServerUrl = () => {
    const baseUrl = `${serverScheme}://${serverUrl}`;
    return serverPort ? `${baseUrl}:${serverPort}` : baseUrl;
};

const handleGraphQLErrors = (errors) => {
    errors.forEach(error => {
        sweetAlertToast(error.message, 'warning');
    });
};

const httpLink = createHttpLink({
    uri: `${buildServerUrl()}${GRAPHQL_ENDPOINT}`
});

const authLink = setContext((_, { headers }) => {
    const accessToken = localStorage.getItem(JWT_TOKEN_KEY);
    return {
        headers: {
            ...headers,
            authorization: accessToken,
        }
    };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        handleGraphQLErrors(graphQLErrors);
    }

    if (networkError?.statusCode === UNAUTHORIZED_STATUS) {
        store.dispatch(doLogout());
    }
});

export const client = new ApolloClient({
    link: from([errorLink, authLink.concat(httpLink)]),
    cache: new InMemoryCache()
});